import React from 'react'
import { Slide, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { isRTL } from '@s4l/utils/library/rtl'

import { type SeverityType, useAlert } from 'src/hooks/useAlert'
import IconClose from 'client/icons/Close'

import type messages from './messages'

import styles from './styles.module.css'

interface IAlertBase {
  severity?: SeverityType
  visible: boolean
  processed: boolean
  containerId?: string
}

export interface IntlMessageType extends IAlertBase {
  title?: string
  messageId: keyof typeof messages
  values: Record<string, string | number>
}

export interface CustomMessageType extends IAlertBase {
  title: string
  description?: string
}

export type IAlertType = IntlMessageType | CustomMessageType

interface IAlertMessageContainer {
  containerId?: string
}

const AlertMessageContainer = ({ containerId }: IAlertMessageContainer) => {
  useAlert({ containerId })

  return (
    <ToastContainer
      className={styles.toastOverride}
      containerId={containerId}
      enableMultiContainer
      position="top-center"
      newestOnTop
      closeOnClick
      draggable
      pauseOnHover
      theme="colored"
      transition={Slide}
      rtl={isRTL()}
      closeButton={<IconClose size={16} />}
    />
  )
}

export default AlertMessageContainer
